export default function vip() {
  return {
    unPayOrders: [],
    /**@type {IVip[] | IGdVip[] } */
    vips: [],
    couponNum: 0,
    /**@type {null | number} */
    downloadLeft: null,
  };
}
